import * as actionTypes from './actionTypes';
import * as api from './api';
import { Toast, normalize } from '../core';

export const getAuditLogs = (params = {}) => dispatch => {
    dispatch({ type: actionTypes.GET_AUDIT_LOGS.REQUEST });
    return api
        .getAuditLogs(params)
        .then(response => {
            const { data, ...pagination } = response.data;
            dispatch({
                type: actionTypes.GET_AUDIT_LOGS.SUCCESS,
                payload: {
                    pagination,
                    ...normalize.normalizeArray(data)
                }
            });
        })
        .catch(error => {
            Toast.error(error);
            dispatch({ type: actionTypes.GET_AUDIT_LOGS.ERROR });
        });
};

export const getAuditAdmins = () => dispatch => {
    dispatch({ type: actionTypes.GET_AUDIT_ADMINS.REQUEST });
    return api
        .getAuditAdmins()
        .then(response => {
            dispatch({ type: actionTypes.GET_AUDIT_ADMINS.SUCCESS, payload: response.data });
        })
        .catch(error => {
            Toast.error(error);
            dispatch({ type: actionTypes.GET_AUDIT_ADMINS.ERROR });
        });
};
